<template>
  <div
    v-if="formSearch.stockState === 3"
    class="stock-wrap"
    key="3"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 导出excel -->
        <el-form-item
          style="float: right; margin-right: 0"
          v-if="funcView.export_stock"
        >
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="exportTable"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <el-form-item
          style="float: right"
          :class="funcView.export_stock ? '' : 'mr-0'"
        >
          <custom-column ref="column1"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input
            :placeholder="$t('dms_stock_out.jshModemSNcpSNckr')"
            v-model="formSearch.search"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container2"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container2"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('dms_stock_out.ISTzhan_dian')">
          <custom-select
            @change="websiteNameChange"
            v-model="formSearch.websiteName"
            filterable
            url="websiteSelectList"
            :params="{ websiteEnv: this.websiteEnv, websiteType: 1 }"
            :model="formSearch"
            :props="{ label: 'websiteName', value: 'websiteName', map: { websiteCode: 'websiteCode' } }"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_out.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :listener="formSearch.websiteCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :params="{ websiteCode: formSearch.websiteCode }"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_out.fa_huo_dan_hao')">
          <el-input v-model="formSearch.shipmentNum"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('dms_stock_out.fa_wang_guo_jia')"
          prop="country"
        >
          <custom-select
            url="factoryDeliveryPlaceSelectList"
            v-model="formSearch.country"
            :props="{ label: 'placeName', value: 'placeName' }"
          ></custom-select>
        </el-form-item>
        <el-form-item
          :label="$t('dms_stock_out.fa_wang_zong_bu')"
          prop="outHqName"
        >
          <el-input v-model="formSearch.outHqName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_out.chu_ku_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.dataTimes"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
            :start-placeholder="$t('dms_stock_out.kai_shi_ri_qi')"
            :end-placeholder="$t('dms_stock_out.jie_shu_ri_qi')"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :index="true"
        :data="tableList"
        :slots="['modemSn', 'websiteName']"
        tableCode="factory_stock_out"
        @sort="sortChange"
        @filter="filterChange"
        @column="setColumn"
        columnRef="column1"
      >
        <template v-slot:websiteName="scope">{{getWebsiteName(scope.row)}}</template>
        <template
          slot="modemSn"
          slot-scope="scope"
        >
          <div
            v-if="funcView.out_stock_modem_details"
            class="cell-link"
            @click="jump('/redirect/boarddetail', { deviceId: scope.row.deviceId, modemSn: scope.row.modemSn, type: 'entire', testType: formSearch.testType, parentPath: $route.path })"
          >
            {{ scope.row.modemSn }}
          </div>
          <span v-else>{{ scope.row.modemSn }}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <out-stock-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getTableList"
    ></out-stock-dialog>
    <!-- 编辑 -->
    <entireItem-dialog
      v-if="dialogVisible2"
      :model="dialogModel2"
      @close="dialogVisible2 = false"
      @success="getTableList"
    ></entireItem-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import outStockDialog from '@/pages/dms/factoryStock/children/out_stock_dialog.vue';
import entireItemDialog from '@/pages/dms/factoryStock/children/entire_Item_dialog.vue';

export default {
  name: '',
  mixins: [resetFormSearchMixins],
  components: {
    outStockDialog,
    entireItemDialog,
  },
  props: {},
  data() {
    return {
      tableSelect: [],

      formSearch: {
        protocolCode: '',
        search: '',
        stockState: 3,
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        imsi: '',
        tcpVersion: '',
        batteryCharge: [],
        dataTimes: [],
        websiteName: '',
        // 发往国家
        country: '',
        // 发往总部:
        outHqName: '',
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},
      // IST 站点列表
      istList: [],
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    initIstList() {
      const reqUrl = apis.websiteSelectList;
      const reqData = { websiteEnv: this.websiteEnv, websiteType: 1 };
      this.$getJSON(reqUrl, reqData).then((res) => {
        this.istList = res.data || [];
      });
    },
    getWebsiteName(row) {
      const istList = this.istList;
      if (istList.length) {
        const item = istList.find(obj => obj.websiteCode === row.websiteCode);
        if (item) {
          return item.websiteName;
        }
      }
      return row.websiteName || '-';
    },
    websiteNameChange() {
      this.formSearch.productCode = '';
    },
    // 判断是否有出库的权限
    // 这个状态等于2才有这个按钮
    checkOutStock(data) {
      const rows = Array.isArray(data) ? [...data] : [data];
      return !rows.some(item => `${item.stockState}` !== '2');
    },
    // 获取列表
    getTableList() {
      this.formSearch.outStartTime = this.formSearch.dataTimes ? this.formSearch.dataTimes[0] : '';
      this.formSearch.outEndTime = this.formSearch.dataTimes ? this.formSearch.dataTimes[1] : '';
      this.formSearch.beginOfBatteryCharge = this.formSearch.batteryCharge ? this.formSearch.batteryCharge[0] : '';
      this.formSearch.endOfBatteryCharge = this.formSearch.batteryCharge ? this.formSearch.batteryCharge[1] : '';
      this.$getJSON(apis.FactoryStockPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    onOutStock: function (row) {
      this.dialogModel.title = this.$t('dms_stock_out.she_bei_chu_ku');
      this.dialogModel.rows = [row];
      this.dialogModel.countryCode = row.countryCode;
      this.dialogModel.websiteCode = row.websiteCode;
      this.dialogVisible = true;
    },
    onSelectOutStock: function () {
      this.dialogModel.title = this.$t('dms_stock_out.she_bei_chu_ku');
      this.dialogModel.rows = this.tableSelect;
      this.dialogModel.countryCode = this.tableSelect[0].countryCode;
      this.dialogModel.websiteCode = this.tableSelect[0].websiteCode;
      this.dialogVisible = true;
    },
    // 数据导出
    exportTable: function () {
      const reqData = {
        ...this.formSearch
      };
      delete reqData.pageSize;
      delete reqData.pageNum;

      this.$exportFlie(apis.factoryStockExport, reqData);
    },
    // 编辑
    onEdit(row) {
      this.dialogModel2.title = this.$t('Common.com_edit');
      this.dialogModel2.type = 'edit';
      this.dialogModel2.data = row;
      this.dialogVisible2 = true;
    },
  },
  created() { },
  mounted() {
    this.initIstList();
    this.getTableList();
    this.getFuncView();
  },
};
</script>

<style></style>
